var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2048_2928)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.54343 3.90647L9.54368 3.90627C10.3316 3.27445 11.6571 3.27298 12.456 3.91507L12.457 3.91589L18.8081 8.99313C18.8084 8.99331 18.8086 8.9935 18.8088 8.99368C19.0757 9.20886 19.3216 9.56877 19.483 9.99191C19.6444 10.415 19.7014 10.8487 19.6459 11.1898C19.6458 11.1901 19.6458 11.1904 19.6457 11.1906L18.4271 18.4839C18.4271 18.4842 18.427 18.4845 18.427 18.4848C18.2473 19.5375 17.1993 20.4237 16.1334 20.4237H5.8667C4.79097 20.4237 3.75266 19.546 3.57311 18.4849C3.57309 18.4848 3.57307 18.4846 3.57305 18.4845L2.35404 11.1888L2.35405 11.1888L2.35352 11.1857C2.29463 10.8463 2.34917 10.414 2.51022 9.99191C2.67123 9.56987 2.91874 9.21031 3.1895 8.9951L3.19093 8.99396L9.54343 3.90647Z",
    fill: "#05B8AD",
    stroke: "#05B8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7917 12.8478C12.7917 13.8374 11.9896 14.6395 11 14.6395C10.0105 14.6395 9.20837 13.8374 9.20837 12.8478C9.20837 11.8583 10.0105 11.0562 11 11.0562C11.9896 11.0562 12.7917 11.8583 12.7917 12.8478Z",
    fill: "#05B8AD",
    stroke: "#05B8AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2048_2928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.931183)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7ab4a1d83b04408301a78c871aabe43f.svg";
export { ForwardRef as ReactComponent };